export default __webpack_public_path__ + "static/media/uploader-insuletOmnipod-1.11f59357.png";